<template>
  <!-- eslint-disable max-len -->
  <div class="route-wrapper">
    <div class="spotlight-card text-grey">
      <h2>Ooops!</h2>
      <div>
        <div class="form-item" style="text-align:left;">
          <h3>{{$t("common.link-expired")}}</h3>
          <p
            class="info text-grey no-account"
            v-html="$t('common.click-here-new-password',{url: url})"
          ></p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line
import Vue from "vue";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import { getQueryParam } from "../shared/utilities";

export default {
  name: "invalidPassword",
  components: {},
  mixins: [validationMixin],
  validations: {
    email: {
      required,
      email
    }
  },
  data() {
    return {
      onSuccessfulReset: false,
      email: "",
      disableButton: false,
      isProcessing: false,
      errors: [],
      url: "/portal/request-password-reset?lang=" + getQueryParam("lang"),
      year: new Date().getFullYear()
    };
  }
};
</script>

<style lang="scss" scoped>
  .spotlight-card {
    align-items: initial;
    justify-content: flex-start;
  }
</style>


